// extracted by mini-css-extract-plugin
module.exports = {"Collapse":"Collapse--1z1A8"};